define('global/UI/SetupInternalPages',[
	'jquery',
	'global/Logger',
	'./Helpers',
    'plugins/slick',
    'plugins/jquery.matchHeights',
    'plugins/equalHeight'
], function ($, Logger, Helpers) {
    'use strict';
    Logger.debug('Setting up Saf-T-Gard Internal Page JS Plugins...');
    var other$ = jQuery;
    //-------------------------
    // Home Page
    //-------------------------

//    var homePagePanelsMatchHeights = Helpers.debounce(function () {
//        var panels = other$(".homepage-panels .panel");
//        if (Helpers.resizeObject.windowWidth >= Helpers.constantsObject.screenMediumMin) {
//            panels.find(".panel-heading").matchHeights();
//            panels.find(".panel-body span").matchHeights();
//			panels.matchHeights();
//        } else {
//            panels.attr("style", "");
//            panels.find(".panel-heading").attr("style", "");
//            panels.find(".panel-body span").attr("style", "");		
//        }
//    }, 10)
//    homePagePanelsMatchHeights();

	$(window).load(function () {
		equalheight('.homepage-panels .homepage-panels-content .panel .panel-heading');
		equalheight('.homepage-panels .homepage-panels-content .panel .panel-body .content');
	});	

    //-------------------------
    // Department Page
    //-------------------------

    var categoryListEqualHeights = Helpers.debounce(function () {
        equalHeight(".rocModule-categories .categoryHeading .title");
        equalHeight(".rocModule-categories .categoryHeading .btnAction");
    }, 50);
    categoryListEqualHeights();
    //-------------------------
    // Listing page
    //-------------------------

    //-------------------------
    // Details page
    //-------------------------
     

    //-------------------------
    // Internal pages
    //-------------------------

    // Binding all the named functions
    //Helpers.resizeFunctionsArray.push(homePagePanelsMatchHeights);
    Helpers.resizeFunctionsArray.push(categoryListEqualHeights);
});

